import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeftCircle } from 'lucide-react';

// THE WAY BACK to the screen a page was opened from (owner, 20 Oct 2026: the
// doctor profile's "Payments ledger" and "Subscription" opened pages with no
// way back and no menu lit).
//
// The opener navigates with
//   state: { navFrom: '/doctorProfile', backTo: { path, state, label } }
// `backTo` draws this button — the same look as the doctor profile's own back
// button — and returns with the opener's state (which doctor, which tab).
// `navFrom` keeps the sidebar on the screen you came from (TwoLevelSidebar).
// Opened from the menu, the page has neither and this renders nothing.
export default function BackToOrigin({ className = 'mb-4' }) {
    const location = useLocation();
    const navigate = useNavigate();
    const backTo = location.state?.backTo;
    if (!backTo?.path) return null;
    return (
        <button
            type="button"
            data-testid="back-to-origin"
            onClick={() => navigate(backTo.path, { state: backTo.state })}
            className={`${className} inline-flex items-center gap-2 bg-gradient-to-r from-[#4ABDBD] to-[#3AA8A8] text-white px-3 py-2 rounded-xl hover:from-[#3AA8A8] hover:to-[#2D8A8A] font-semibold text-sm transition-all duration-300 cursor-pointer shadow-md`}
        >
            <ArrowLeftCircle className="h-5 w-5" />
            {backTo.label && <span>{backTo.label}</span>}
        </button>
    );
}
